/* import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance-modal.component.html',
  styleUrls: ['./maintenance-modal.component.scss']
})
export class MaintenanceModalComponent implements OnInit {
  isVisible = true;

  ngOnInit(): void {
    this.isVisible = true;
  }

  cerrarModal(): void {
    this.isVisible = false;
  }
} */

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-maintenance-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="isVisible"
      style="
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: rgba(0, 0, 0, 0.65);
      "
    >
      <div
        style="
          width: min(420px, 100%);
          padding: 32px;
          background: #fff;
          border-top: 6px solid #96c34a;
          border-radius: 14px;
          text-align: center;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
        "
      >
        <button
          type="button"
          aria-label="Cerrar"
          (click)="cerrarModal()"
          style="
            float: right;
            border: 0;
            background: transparent;
            color: #365522;
            font-size: 28px;
            cursor: pointer;
          "
        >
          &times;
        </button>

        <h2 style="margin: 24px 0 12px; color: #365522;">
          Plataforma en mantenimiento
        </h2>

        <p style="margin: 0; color: #3f4740; line-height: 1.55;">
          Estamos realizando ajustes en la plataforma VITAL.
          Nuestro equipo ya está trabajando en la solución.
        </p>

        <button
          type="button"
          (click)="cerrarModal()"
          style="
            margin-top: 24px;
            padding: 10px 28px;
            border: 0;
            border-radius: 8px;
            background: #5f8f2f;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
          "
        >
          Entendido
        </button>
      </div>
    </div>
  `
})
export class MaintenanceModalComponent {
  isVisible = true;

  cerrarModal(): void {
    this.isVisible = false;
  }
}